import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSlideOut32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowSlideOut32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M11.844 5.906c3.153 0 5.967 1.447 7.818 3.711l-1.704 1.715a7.693 7.693 0 1 0-.023 9.363l1.713 1.703a10.07 10.07 0 0 1-7.804 3.694c-5.574 0-10.093-4.519-10.093-10.093S6.27 5.907 11.844 5.906m12.562 5.808a1.2 1.2 0 0 1 1.698 0l3.336 3.337q.09.074.163.163l.772.771-4.271 4.27a1.2 1.2 0 0 1-1.698-1.696l1.382-1.382h-8.59a1.2 1.2 0 0 1 0-2.4h8.575l-1.366-1.366a1.2 1.2 0 0 1 0-1.697"
            />
        </svg>
    );
}
export default memo(IconArrowSlideOut32);
